import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Table, Space, Popconfirm, message, Modal, Input, Form } from 'antd';
import { Link } from 'react-router-dom';
import { EditTwoTone, RightOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { inventoryOpenList, inventorySaveOften, inventoryDeleteOften, inventoryOftenCoCart } from './api';
import './index.less';


export default function PurchasingList() {
  const history = useHistory();
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [current, setCurrent] = useState({});
  const [currentType, setCurrentType] = useState(undefined);
  const [visible, setVisible] = useState(false);
  const columns = [
    // {
    //   title: '序号',
    //   dataIndex: 'id',
    //   key: 'id',
    //   width: 100,
    //   align: 'center',
    // },
    {
      title: '清单名称',
      dataIndex: 'name',
      key: 'name',
      width: 400,
      align: 'center',
      render: (text, record,) => <div className='purchasing-list-item'>{text} <span className='purchasing-list-item-edit-icon'><EditTwoTone twoToneColor='#ff4d4f' onClick={() => modifyItem(record)} /></span></div>
    },
    {
      title: '商品数',
      dataIndex: 'lists',
      key: 'lists',
      width: 200,
      align: 'center',
      render: text => (text || []).length,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      align: 'center',
      render: (text, record) => {
        const { lists = [] } = record;
        return <Space>
          {/* <Button size='small' type='primary' onClick={() => modifyItem(record)}>编辑</Button> */}
          <Button size='small' type='primary' onClick={() => toPurchasingDetail(record)}>配置商品</Button>
          <Popconfirm title='确定要删除该清单吗？' onConfirm={() => deleteItem(record)}><Button size='small' type='primary'>删除</Button></Popconfirm>
          <Popconfirm disabled={!lists?.length} title='请选择是否清空订货清单已有商品，再加入该常购清单商品？' cancelText='清空已有商品' okText='不清空已有商品' onCancel={() => onCancel(record)} onConfirm={() => onConfirm(record)}>
            <Button disabled={!lists?.length} size='small' type='primary' >加入订货清单</Button>
          </Popconfirm>
        </Space>;
      }
    },
  ];
  async function requestInventoryOpenList() {
    const { data: { data = {}, msg, code } } = await inventoryOpenList();
    if (+code === 0) {
      const { list = [] } = data;
      setDataSource(list);
    } else {
      message.error(msg);
    }
  }
  useEffect(() => {
    requestInventoryOpenList();
  }, []);

  const add = () => {
    setVisible(true);
    setCurrentType('add');
    setCurrent({});
    form.setFieldsValue({ name: '' });
  };
  const modifyItem = record => {
    setVisible(true);
    setCurrentType('modify');
    setCurrent(record);
    form.setFieldsValue({ name: record.name });
  };
  const toPurchasingDetail = record => {
    history.push(`/basic/user/proposalCart/purchasingDetail?id=${record?.id}`);
  };
  const deleteItem = async (record) => {
    const { data: { msg, code } } = await inventoryDeleteOften({ ...record });
    if (+code === 0) {
      message.success(msg);
      requestInventoryOpenList();
      setVisible(false);
      setCurrentType(undefined);
    } else {
      message.error(msg);
    }
  };
  const onCancel = record => requestInventoryOftenCoCart({ ...record, type: 1 });
  const onConfirm = record => requestInventoryOftenCoCart({ ...record, type: 2 });
  const requestInventoryOftenCoCart = async (params) => {
    const { data: { msg, code } } = await inventoryOftenCoCart({ ...params });
    if (+code === 0) {
      message.success('商品加入成功', 2, () => {
        history.push('/basic/user/proposalCart');
      });
    } else {
      message.error(msg);
    }
  };
  const cancel = () => setVisible(false);
  const onOk = () => {
    cancel();
  };
  const handleOnBlur = (e) => {
    const value = e.target.value?.trim();
    form.setFieldsValue({ name: value });
  };
  const onFinish = async (values) => {
    const { data: { msg, code } } = await inventorySaveOften({ ...current, ...values });
    if (+code === 0) {
      message.success(msg);
      requestInventoryOpenList();
      setVisible(false);
      setCurrentType(undefined);
      setCurrent({});
    } else {
      message.error(msg);
    }
  };
  return (
    <div className="proposal-order-list">
      <Space style={{ marginTop: 20, marginBottom: 10 }} split={<RightOutlined />}>
        <Link to={{ pathname: '/basic/user/proposalCart' }}>订货清单</Link>
        <Link to={{ pathname: '/basic/user/proposalCart/purchasingList' }}>常购清单</Link>
      </Space>
      <div className="title">常购清单</div>
      <Row><Col span={4} offset={20} style={{ textAlign: 'right', marginBottom: 10 }}><Button type='primary' onClick={add}>添加</Button></Col></Row>
      <Table dataSource={dataSource} columns={columns} pagination={false} rowKey='id' locale={{ emptyText: '抱歉！暂无长购清单信息' }} />
      <Modal title={`${currentType === 'add' ? '添加' : '编辑'}常购清单名称`} open={visible} destroyOnClose forceRender onCancel={cancel} onOk={onOk} footer={false} >
        <Form form={form} onFinish={onFinish} >
          <Form.Item label='清单名称：' name="name" rules={[{ required: true, message: '请输入清单名称!' }]}><Input maxLength={30} placeholder='请输入清单名称' onBlur={handleOnBlur} /></Form.Item>
          <Row>
            <Col offset={6} span={6} >
              <Form.Item><Button className='erp-map-form-btn' type='primary' htmlType="submit">确认</Button></Form.Item>
            </Col>
            <Col offset={4} span={6}>
              <Form.Item><Button className='erp-map-form-btn erp-map-form-btn-cancel' onClick={cancel}>取消</Button></Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
}
